export const getAttachmentFileNameForDisplay = (
  item,
  suffixExtension = false,
) => {
  let ret = item.desc || item.name;
  if (suffixExtension && item.ext) ret = `${ret}.${item.ext}`;

  return ret;
};
